import { render, staticRenderFns } from "./ChartDesc.vue?vue&type=template&id=96d62890&scoped=true"
import script from "./ChartDesc.vue?vue&type=script&lang=js"
export * from "./ChartDesc.vue?vue&type=script&lang=js"
import style0 from "./ChartDesc.vue?vue&type=style&index=0&id=96d62890&prod&lang=scss&scoped=true"
import style1 from "./ChartDesc.vue?vue&type=style&index=1&id=96d62890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d62890",
  null
  
)

export default component.exports